import { default as calculationESqUJ2MV2UMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detaildFP6jGlZ2xMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryC0G0HDC0OxMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93FiYzI4mPIMMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listgFcis5BH4GMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingAOjNY30U4RMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyouHZkli1QVq3Meta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellTNWT5c5satMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadost2vrjN4194iMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankHlJBfYXyRcMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnanik4LPM8Q1OPMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pageX0JBL4CsG0Meta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testrfSNM6Fqa2Meta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepage0IZQgTHW1aMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleDEK3oUc1pqMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsXH7MVWkZXkMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagKRqx79dqGSMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autor46SFqv4vMlMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryoe5gSkRdWsMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionyQaz30rs8DMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articles9MqqKBEAlfMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryMIdlun2yxoMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articlevh5qUYJIc1Meta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as section5pxNP94lLjMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contacts3RIpIPGRxMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationL4pgzoxGzqMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculation1nz2gfNtgKMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youhsxxKyFs6ZMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailmG9Ki293ZAMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryBo8Y9HOwASMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listOplFUFhdXhMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculation6PISIR54xiMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45you9u8vEragGCMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryfCVIAdNCOtMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listI50bfqkjExMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detail0wQVwhryEwMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offerigVymWhQMEMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryDnnCB0DKSJMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youJUHSbtqZ0fMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationTaZGakGKgVMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listXMqKEcsiZJMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youu0GZMJD1DFMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineSJsEog0sAIMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailjheMnDMVa8Meta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneMjpvq461AZMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerlHKCIfXHRtMeta } from "/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadost2vrjN4194iMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankHlJBfYXyRcMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnanik4LPM8Q1OPMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pageX0JBL4CsG0Meta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testrfSNM6Fqa2Meta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepage0IZQgTHW1aMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleDEK3oUc1pqMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsXH7MVWkZXkMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagKRqx79dqGSMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autor46SFqv4vMlMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryoe5gSkRdWsMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionyQaz30rs8DMeta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articles9MqqKBEAlfMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageX0JBL4CsG0Meta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryMIdlun2yxoMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articlevh5qUYJIc1Meta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: section5pxNP94lLjMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: section5pxNP94lLjMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contacts3RIpIPGRxMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationL4pgzoxGzqMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculation1nz2gfNtgKMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youhsxxKyFs6ZMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailmG9Ki293ZAMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryBo8Y9HOwASMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listOplFUFhdXhMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculation6PISIR54xiMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45you9u8vEragGCMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryfCVIAdNCOtMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listI50bfqkjExMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detail0wQVwhryEwMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offerigVymWhQMEMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryDnnCB0DKSJMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youJUHSbtqZ0fMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationTaZGakGKgVMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listXMqKEcsiZJMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youu0GZMJD1DFMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineSJsEog0sAIMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailjheMnDMVa8Meta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneMjpvq461AZMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerlHKCIfXHRtMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src1962364245/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]